import { Attribute, Directive, ElementRef, Inject, Input, OnInit, Optional, Renderer2 } from '@angular/core';
import { TABLE_WRAPPER_DESIGN_VERSION_TOKEN } from '@shared/ui-ux-components/ui-ux-components.config';

@Directive({
  selector: 'cwc-table-wrapper, cwc-table',
})
export class UiUxTableWrapperProviderDirective implements OnInit {
  constructor(
    private rdr2: Renderer2,
    private host: ElementRef,
    @Optional() @Attribute('design-version') private designVersionAttribute?: string,
    @Optional() @Inject(TABLE_WRAPPER_DESIGN_VERSION_TOKEN) private designVersionToken?: string,
  ) {
    if (designVersionAttribute) {
      console.warn(
        '☸ For better performance, dynamic updates, type safety, and code consistency, please prefer using property binding.',
      );
    }
  }

  @Input()
  public designVersion!: string;

  public ngOnInit() {
    const designVersion = this.designVersion || this.designVersionAttribute || this.designVersionToken;

    if (designVersion) {
      this.rdr2.setProperty(this.host.nativeElement, 'designVersion', designVersion);
    }
  }
}
